import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    suppliersGet,
    supplierGetById,
    supplierInsert,
    supplierUpdate,
    supplierDelete,
    requestSupplierContactsGet,
    requestSupplierContactsGetById,
    requestSupplierContactsCreate,
    requestSupplierContactsUpdateById,
    requestSupplierContactsDeleteById,

    requestSupplierGetUsers,
    requestSupplierGetUsersById,
    requestSupplierCreateUsers,
    requestSupplierUpdateUsers,
    requestSupplierDeleteUsers
} from "api/menu/master-files/suppliers/requests";

export const FETCH_SUPPLIERS_SUCCESS = "FETCH_SUPPLIERS_SUCCESS";
export const FETCH_SUPPLIER_BY_ID_SUCCESS = "FETCH_SUPPLIER_BY_ID_SUCCESS";

export const SUPPLIER_REQUEST_LOADING = "SUPPLIER_REQUEST_LOADING";
export const SUPPLIER_REQUEST_ERRORS = "SUPPLIER_REQUEST_ERRORS";

export const FETCH_SUPPLIERS_CONTACTS_SUCCESS = "FETCH_SUPPLIERS_CONTACTS_SUCCESS";
export const FETCH_SUPPLIERS_CONTACTS_CREATE_SUCCESS = "FETCH_SUPPLIERS_CONTACTS_CREATE_SUCCESS";
export const FETCH_SUPPLIERS_CONTACTS_DELETE_SUCCESS = "FETCH_SUPPLIERS_CONTACTS_DELETE_SUCCESS";

export const FETCH_SUPPLIERS_USERS_GET_SUCCESS = "FETCH_SUPPLIERS_USERS_GET_SUCCESS";
export const FETCH_SUPPLIERS_USERS_CREATE_SUCCESS = "FETCH_SUPPLIERS_USERS_CREATE_SUCCESS";
export const FETCH_SUPPLIERS_USERS_DELETE_SUCCESS = "FETCH_SUPPLIERS_USERS_DELETE_SUCCESS";

const setLoading = (status = true) => ({
    type: SUPPLIER_REQUEST_LOADING,
    payload: status
});

export const fetchSuppliersList = (includeInactive = false) => dispatch => {
    dispatch(setLoading());
    suppliersGet(includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIERS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};

export const fetchSupplierById = (id) => dispatch => {
    dispatch(setLoading());
    supplierGetById(id)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIER_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};

export const insertSupplier = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    supplierInsert(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new Supplier "${data.name}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateSupplier = (id, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    supplierUpdate(id, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Supplier "${data.name}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteSupplier = (id, name, callback = false) => dispatch => {
    dispatch(setLoading());
    supplierDelete(id)
        .then(() => {
            toast(`Supplier "${name}" has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};

export const clearSuppliersList = () => dispatch => {
    dispatch({
        type: FETCH_SUPPLIERS_SUCCESS,
        payload: []
    });
};

export const clearSupplier = () => dispatch => {
    dispatch({
        type: FETCH_SUPPLIER_BY_ID_SUCCESS,
        payload: {}
    });
};

export const supplierContactsGet = (supplierId) => dispatch => {
    dispatch(setLoading());
    requestSupplierContactsGet(supplierId)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIERS_CONTACTS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};

export const supplierContactsGetById = (supplierId, contactId, callback) => dispatch => {
    dispatch(setLoading());
    requestSupplierContactsGetById(supplierId, contactId)
        .then(response => {
            callback(response.data);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};

export const supplierContactsCreate = (supplierId, data, callback) => dispatch => {
    dispatch(setLoading());
    requestSupplierContactsCreate(supplierId, data)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIERS_CONTACTS_CREATE_SUCCESS,
                payload: response.data
            });
            callback(true);
            toast("Contact created successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
            callback(false);
        });
};

export const supplierContactsUpdateById = (supplierId, contactId, data, callback) => dispatch => {
    dispatch(setLoading());
    requestSupplierContactsUpdateById(supplierId, contactId, data)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIERS_CONTACTS_CREATE_SUCCESS,
                payload: response.data
            });
            callback(true);
            toast("Contact updated successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
            callback(false);
        });
};

export const supplierContactsDeleteById = (supplierId, contactId) => dispatch => {
    dispatch(setLoading());
    requestSupplierContactsDeleteById(supplierId, contactId)
        .then(() => {
            dispatch({
                type: FETCH_SUPPLIERS_CONTACTS_DELETE_SUCCESS,
                payload: contactId
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};

export const supplierGetUsers = (supplierId) => dispatch => {
    if (supplierId === false) {
        dispatch({
            type: FETCH_SUPPLIERS_USERS_GET_SUCCESS,
            payload: []
        });
        return;
    }
    dispatch(setLoading());
    requestSupplierGetUsers(supplierId)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIERS_USERS_GET_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};

export const supplierGetUsersById = (userId, callback) => dispatch => {
    dispatch(setLoading());
    requestSupplierGetUsersById(userId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
            dispatch(setLoading(false));
        });
};

export const supplierCreateUsers = (supplierId, data, callback) => dispatch => {
    dispatch(setLoading());
    requestSupplierCreateUsers(supplierId, data)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIERS_USERS_CREATE_SUCCESS,
                payload: response.data
            });
            callback(true);
            toast("User created successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
            callback(false);
        });
};

export const supplierUpdateUsers = (supplierId, userId, data, callback) => dispatch => {
    dispatch(setLoading());
    requestSupplierUpdateUsers(supplierId, userId, data)
        .then(response => {
            dispatch({
                type: FETCH_SUPPLIERS_USERS_CREATE_SUCCESS,
                payload: response.data
            });
            callback(true);
            toast("User updated successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
            callback(false);
        });
};

export const supplierDeleteUsers = (userId) => dispatch => {
    dispatch(setLoading());
    requestSupplierDeleteUsers(userId)
        .then(() => {
            dispatch({
                type: FETCH_SUPPLIERS_USERS_DELETE_SUCCESS,
                payload: {
                    id: userId
                }
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SUPPLIER_REQUEST_ERRORS));
        });
};
